import { Badge, Button, CloseButton, OverlayTrigger, Popover, Stack } from "react-bootstrap";
import { ArrowCounterclockwise, PlusLg } from "react-bootstrap-icons";
import { axiosInstance } from "../../auth/Auth";
import { Typeahead } from "react-bootstrap-typeahead";
import ConfirmPrompt from "../ConfirmPrompt";
import { Suspense, useState } from "react";
import { Await, useLoaderData } from "react-router-dom";

export default function BreakContentGroups({ item, onContentGroupsUpdate, radioId, filterFunction = () => true }) {
    const { contentGroups } = useLoaderData();

    const [showContentGroupsResetConfirmPrompt, setShowContentGroupsResetConfirmPrompt] = useState(false);
    const [selectedBreakId, setSelectedBreakId] = useState(null);

    async function addContentGroupToBreak(groupId) {
        try {
            setSelectedBreakId(null);
            const groups = [...item.content_groups, groupId];
            onContentGroupsUpdate(groups);
            await axiosInstance.post(`/content_testing/${item.break_id}/content_groups/${groupId}`);
        } catch (error) {
            console.error(error);
        }
    }
    async function removeContentGroupFromBreak(groupId) {
        try {
            const groups = item.content_groups.filter(x => x !== groupId);
            onContentGroupsUpdate(groups);
            await axiosInstance.delete(`/content_testing/${item.break_id}/content_groups/${groupId}`);
        } catch (error) {
            console.error(error);
        }
    }
    async function resetContentGroups() {
        try {
            onContentGroupsUpdate(item.content_groups_original);
            setShowContentGroupsResetConfirmPrompt(false);
            await axiosInstance.post(`/content_testing/${item.break_id}/reset/?content_group=${true}&keyword=${false}`);
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <>
            <Suspense>
                <Await resolve={contentGroups}>
                    {resolvedContentGroups => (
                        <Stack direction="horizontal" gap={1} className="flex-wrap">
                            {item.content_groups.map((x, i) => (
                                <Badge key={`${item.break_id}-${i}`} className="bg-ra-alternative-yellow text-dark fw-bold">
                                    {resolvedContentGroups.data.find(g => g.group_id === x)?.display_name}
                                    <CloseButton className="py-0" onClick={async () => await removeContentGroupFromBreak(x)} />
                                </Badge>
                            ))}
                            <Stack direction="horizontal" gap={1}>
                                <OverlayTrigger
                                    trigger={"click"}
                                    show={selectedBreakId === item.break_id}
                                    rootClose={true}
                                    onToggle={val => setSelectedBreakId(item.break_id === selectedBreakId ? val : true)}
                                    placement="bottom-start"
                                    overlay={
                                        <Popover>
                                            <Popover.Body className="p-0">
                                                <Typeahead
                                                    id={`${item.break_id}-new-group`}
                                                    size="sm"
                                                    options={resolvedContentGroups.data.filter(filterFunction)}
                                                    labelKey={"display_name"}
                                                    highlightOnlyResult
                                                    placeholder="Add content group..."
                                                    clearButton={true}
                                                    onChange={async value => await addContentGroupToBreak(value[0].group_id)}
                                                    selected={[]}
                                                    open
                                                />
                                            </Popover.Body>
                                        </Popover>
                                    }>
                                    <Button
                                        className="btn-ra-yellow d-flex p-1"
                                        size="sm"
                                        onClick={() => {
                                            setSelectedBreakId(item.break_id);
                                        }}>
                                        <PlusLg />
                                    </Button>
                                </OverlayTrigger>
                                <Button
                                    size="sm"
                                    variant="danger"
                                    title="Reset content group changes."
                                    disabled={JSON.stringify(item.content_groups) === JSON.stringify(item.content_groups_original)}
                                    className=" d-flex align-items-center py-0 px-0"
                                    onClick={() => setShowContentGroupsResetConfirmPrompt(true)}>
                                    <ArrowCounterclockwise height={22} width={22} />
                                </Button>
                            </Stack>
                        </Stack>
                    )}
                </Await>
            </Suspense>

            <ConfirmPrompt
                show={showContentGroupsResetConfirmPrompt}
                handleClose={() => setShowContentGroupsResetConfirmPrompt(false)}
                handleConfirm={() => resetContentGroups()}
                confirmText="Reset"
                cancelText="Keep current"
                bodyText="Are you sure you want to reset content groups to original values? Any modifications will be lost."
            />
        </>
    );
}
